import { render, staticRenderFns } from "./Section6.vue?vue&type=template&id=3b84dcd8"
import script from "./Section6.vue?vue&type=script&lang=js"
export * from "./Section6.vue?vue&type=script&lang=js"
import style0 from "./Section6.vue?vue&type=style&index=0&id=3b84dcd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports